import CommercialHallApi from '@/api/project/commercialHallApi.js'
import { normalizeSchemeOpportunityItem } from '../adapters/index.js'

export async function fetchSchemeOpportunityList(limit = {}, raw = false) {
  const res = await CommercialHallApi.listByType(limit)
  if (res?.code !== '00000') return { rows: [], totalRows: 0, raw: res }

  const rows = Array.isArray(res.rows) ? res.rows : []
  return {
    rows: raw ? rows : rows.map(normalizeSchemeOpportunityItem).filter(Boolean),
    totalRows: res.totalRows || rows.length || 0,
    raw: res
  }
}

export async function fetchSchemeOpportunityDetail(id) {
  if (!id) return null

  const res = await CommercialHallApi.getById(id)
  if (res?.code !== '00000') return null

  return normalizeSchemeOpportunityItem(res.model || null)
}

export async function createSchemeOpportunity(payload = {}) {
  return CommercialHallApi.addModel(payload || {})
}

export async function updateSchemeOpportunity(id, payload = {}) {
  if (!id) throw new Error('missing id')
  return CommercialHallApi.editModel(id, payload || {})
}

export async function fetchSchemePostedOpportunityList(companyId, raw = false) {
  if (!companyId) return []
  const res = await CommercialHallApi.listByType({
    pagination: false,
    companyId,
    type: 'Resources',
    status: ['Completed']
  })
  if (!res || !Array.isArray(res.rows)) return []
  return raw ? res.rows : res.rows.map(normalizeSchemeOpportunityItem).filter(Boolean)
}
